import { SimulationProvider } from './contexts/SimulationContext';
import Simulator from './components/Simulation/Simulator';
import { ErrorBoundary } from '@sentry/react';
import ErrorFallback from './components/Error/ErrorFallback';

const App: React.FC = () => {
  return (
    <ErrorBoundary fallback={<ErrorFallback />}>
      <SimulationProvider>
        <Simulator />
      </SimulationProvider>
    </ErrorBoundary>
  );
};

export default App;
